import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  registerTypeWrapper: {
    margin: theme.spacing(3, 0, 2),
  },
  labelRow: {
    marginBottom: theme.spacing(2),
  },
}));
